import React, { Component } from 'react'
import { scrollTo } from '../utils'
import { StepStores } from './Components'
import { badaPropTypes, badaDefaultProps } from '../../../../types'
import tracker from '../../../../utils/tracker'

class StoresStep extends Component {
  render() {
    const {
      props: {
        badaProps: { store, stores },
        wizard: {
          step: { one },
        },
        preselected,
        storeId,
        fallbackAddress,
        selectedAddress,
        selectedCity,
        selectedStore,
        selectedStoreUnavailable,
        customerAddress,
        updateUiState,
        storesByAddressData,
        history,
        flow,
      },
    } = this.props

    const cityName = selectedAddress?.city || ''
    const cityValue =
      !storesByAddressData.loading &&
      !selectedCity &&
      selectedAddress &&
      selectedAddress.postalCode
        ? cityName || selectedAddress.postalCode
        : selectedCity

    return (
      <>
        <StepStores
          show={one}
          props={{
            storeId,
            store,
            stores,
            fallbackAddress,
            selectedAddress,
            selectedCity: cityValue || fallbackAddress?.city,
            selectedStore,
            selectedStoreUnavailable,
            checked: !!store,
            storesByAddressData,
            customerAddress,
            storeIsPreSelectable: preselected,
            flow,
            onChange: (state) => {
              const service = {}
              if (!state.preselected) {
                service.selectedService = null
              }

              updateUiState({
                ...state,
                ...service,
              })

              if (
                state.selectedStore &&
                !state.preselected &&
                !state.preSelectedMeetingTypeId
              ) {
                history.push(`${window.location.search}#select`, {
                  ...state,
                  ...service,
                  selectedService: null,
                  bookingCompleted: false,
                })

                scrollTo(this.ref)
              }
              if (state.selectedAddress && !state.selectedAddress?.device) {
                history.push(`${window.location.search}#location`, {
                  ...state,
                })
                scrollTo(this.ref)
              }

              if (state.selectedStore && !state.preselected) {
                tracker.trackClick(
                  'BADA 2.0 pick a store',
                  `${state.selectedStore.name} - ${state.selectedStore.id} - ${state.selectedStore.distanceInKilometers}km`,
                  { flow }
                )
              }
            },
          }}
        />
        <div
          ref={(ref) => {
            this.ref = ref
          }}
        />
      </>
    )
  }
}

StoresStep.propTypes = {
  ...badaPropTypes,
}

StoresStep.defaultProps = {
  ...badaDefaultProps,
}

export default StoresStep
